import { render, staticRenderFns } from "./diyMenu.vue?vue&type=template&id=447411d4"
import script from "./diyMenu.vue?vue&type=script&lang=js"
export * from "./diyMenu.vue?vue&type=script&lang=js"
import style0 from "./diyMenu.vue?vue&type=style&index=0&id=447411d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports